import { FC } from 'react';
import { IDocument, IQuarters } from '../types';
import FinancialQuarterBtn from './FinancialQuarterBtn';

interface IProps {
  quarters: IQuarters;
}

const FinancialQuarters: FC<IProps> = ({ quarters }) => {
  return (
    <div className="financial-results__table--calendar-row">
      <div className="financial-results__table--quarter-btns-container">
        {Object.values(quarters).map((documentUrl: IDocument, index) => (
          <FinancialQuarterBtn
            key={index}
            quarterNumber={index + 1}
            documentUrl={documentUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default FinancialQuarters;
